import React, { useEffect, useState, useRef } from 'react';
import Button from '../ui/Button';
const ContactCTA = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entries[0].target);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="py-16 bg-[#1a2e1a] relative overflow-hidden" data-id="element-101">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-102">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" data-id="element-103">
          <pattern id="pattern" width="10" height="10" patternUnits="userSpaceOnUse" data-id="element-104">
            <circle cx="1" cy="1" r="1" fill="white" data-id="element-105" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#pattern)" data-id="element-106" />
        </svg>
      </div>
      <div className={`container mx-auto px-4 md:px-6 relative z-10 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-107">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-108">
          Ready to Start Your Next Project?
        </h2>
        <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-109">
          Contact us today to discuss how Socrates and Richard Company can bring
          your vision to life with expert craftsmanship and professional
          service.
        </p>
        <Button to="/contact" variant="primary" size="lg" data-id="element-110">
          Contact Us
        </Button>
      </div>
    </section>;
};
export default ContactCTA;